// home.js
import React, { useEffect, useRef } from 'react';
import styles from './home.module.css';

function Home() {
const fraseContainerRef = useRef(null);

useEffect(() => {
    // Efecto de carga inicial
    setTimeout(() => {
    if (fraseContainerRef.current) {
        fraseContainerRef.current.style.opacity = '1';
    }
    }, 100);
}, []);

return (
    <section id='home' className={styles.home}>
    <div className={styles.foto}>
        <div 
        ref={fraseContainerRef}
        className={styles.fraseContainer}
        style={{ opacity: 0 }}
        >
        <div className={styles.frase}>
            <p>Lautaro Mazza ha resuelto entrar al mundo del tango renunciando a toda inocencia. Comprendiendo los peligros de una actitud complaciente consigo mismo, enfrentó las fatigas del estudio. Desdeñó los consejos engañosos que le sugerían ser auténtico o ser él mismo, por entender que eso no significaba nada. Y empezó a construir una voz día tras día, con gran esfuerzo, siguiendo las enseñanzas de verdaderos maestros. Tuvo también la precaución de aprender no solo música, porque entendió que un artista tiene la obligación de comprender cómo funciona el mundo. Y de ejercitarse en el pensamiento y aún en la ética. De este modo, para el asombro de algunos extraños como yo, se convirtió en uno de los dos mejores cantores de este país. Su voz no tiene imperfecciones, su afinación es perfecta. La elección de su repertorio indica que conoce una amarga verdad: no todos los tangos son buenos. Y por otra parte ha diseñado, con toda intencionalidad, un control de sus versiones, con impecable selección de tempos, fraseos y nobles "manieras" que son propias del género.</p>
            <p>Así las cosas, Lautaro no tiene necesidad de hacer trampa. Puede prescindir de ademanes y patadas en el piso. No tiene que dar explicaciones después de cada canción. Parece sencillo pero es venturosamente complejo.</p>
            <p className={styles.firma}>Alejandro Dolina</p>
        </div>
        </div>
    </div>
    </section>
);
}

export default Home;